"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const constants_1 = require("./../constants");
const storeValidation_1 = __importDefault(require("./validations/storeValidation"));
const types_1 = require("../types");
const drippingFormUtil_1 = __importDefault(require("../utils/drippingFormUtil"));
class DrippingFormStore {
    constructor() {
        this.drippingId = constants_1.INITIAL_FIELDS.drippingId;
        this.key = drippingFormUtil_1.default.generateKey();
        this.isReleaseEnabled = constants_1.INITIAL_FIELDS.switchEnabled;
        this.releaseDrippingType = constants_1.INITIAL_FIELDS.releaseDrippingType;
        this.releaseNumberOfDays = constants_1.INITIAL_FIELDS.numberOfDays;
        this.releaseDateTimeISO = constants_1.INITIAL_FIELDS.releaseDateTimeISO;
        this.isExpirationEnabled = constants_1.INITIAL_FIELDS.switchEnabled;
        this.expirationNumberOfDays = constants_1.INITIAL_FIELDS.numberOfDays;
        this.classType = constants_1.INITIAL_FIELDS.classType;
        this.selectedClasses = constants_1.INITIAL_FIELDS.selectedClasses;
        this.quizId = constants_1.INITIAL_FIELDS.quizId;
        this.quizRequiresMinimumScore = false;
        this.quizDetails = new Map();
        this.setQuizId = (value) => {
            this.quizId = value;
        };
        this.setQuizRequiresMinimumScore = (value) => {
            this.quizRequiresMinimumScore = value;
        };
        this.addQuizDetails = (quizId, quizDetails) => {
            const existingQuizDetails = this.quizDetails.get(quizId);
            this.quizDetails.set(quizId, { ...existingQuizDetails, ...quizDetails });
        };
    }
    setIsReleaseEnabled(isEnabled) {
        this.isReleaseEnabled = isEnabled;
    }
    setReleaseDrippingType(releaseDrippingType) {
        this.releaseDrippingType = releaseDrippingType;
        if (releaseDrippingType !== types_1.ReleaseDrippingTypes.SpecificDate) {
            this.releaseDateTimeISO = constants_1.INITIAL_FIELDS.releaseDateTimeISO;
        }
        if (releaseDrippingType !== types_1.ReleaseDrippingTypes.DaysAfter) {
            this.releaseNumberOfDays = constants_1.INITIAL_FIELDS.numberOfDays;
        }
        if (releaseDrippingType !== types_1.ReleaseDrippingTypes.Quiz) {
            this.quizId = constants_1.INITIAL_FIELDS.quizId;
        }
    }
    setReleaseNumberOfDays(value) {
        this.releaseNumberOfDays = value;
    }
    setReleaseDateTimeValue(value) {
        this.releaseDateTimeISO = value;
    }
    setIsExpirationEnabled(isEnabled) {
        this.isExpirationEnabled = isEnabled;
    }
    setExpirationNumberOfDays(value) {
        this.expirationNumberOfDays = value;
    }
    setClassType(value) {
        this.classType = value;
        if (value === types_1.ClassTypes.All) {
            this.selectedClasses = constants_1.INITIAL_FIELDS.selectedClasses;
        }
    }
    setSelectedClasses(classItem, isChecked) {
        if (isChecked) {
            this.selectedClasses = [...this.selectedClasses, classItem];
        }
        else {
            this.selectedClasses = this.selectedClasses.filter((item) => item.id !== classItem.id);
        }
    }
    setAllFields(dripping) {
        this.drippingId = dripping.id;
        this.key = dripping.key;
        if (dripping.releaseDays !== constants_1.INITIAL_FIELDS.numberOfDays) {
            this.setIsReleaseEnabled(true);
            this.setReleaseDrippingType(types_1.ReleaseDrippingTypes.DaysAfter);
            this.setReleaseNumberOfDays(dripping.releaseDays);
        }
        else if (dripping.releaseDate) {
            this.setIsReleaseEnabled(true);
            this.setReleaseDrippingType(types_1.ReleaseDrippingTypes.SpecificDate);
            this.setReleaseDateTimeValue(dripping.releaseDate);
        }
        else if (dripping.pageId) {
            this.setIsReleaseEnabled(true);
            this.setReleaseDrippingType(types_1.ReleaseDrippingTypes.Quiz);
            this.setQuizId(dripping.pageId);
        }
        if (dripping.expirationDays !== constants_1.INITIAL_FIELDS.numberOfDays) {
            this.setIsExpirationEnabled(true);
            this.setExpirationNumberOfDays(dripping.expirationDays);
        }
        this.setClassType(dripping.allClasses ? types_1.ClassTypes.All : types_1.ClassTypes.Specific);
        dripping.classes.forEach(({ hashId, name, defaultClass }) => {
            const isChecked = true;
            this.setSelectedClasses({
                id: hashId,
                name,
                defaultClass
            }, isChecked);
        });
    }
    clearReleaseFields() {
        this.setIsReleaseEnabled(constants_1.INITIAL_FIELDS.switchEnabled);
        this.setReleaseDrippingType(constants_1.INITIAL_FIELDS.releaseDrippingType);
        this.setReleaseNumberOfDays(constants_1.INITIAL_FIELDS.numberOfDays);
        this.setReleaseDateTimeValue(constants_1.INITIAL_FIELDS.releaseDateTimeISO);
        this.setQuizId(constants_1.INITIAL_FIELDS.quizId);
    }
    clearExpirationFields() {
        this.setIsExpirationEnabled(constants_1.INITIAL_FIELDS.switchEnabled);
        this.setExpirationNumberOfDays(constants_1.INITIAL_FIELDS.numberOfDays);
    }
    clearClassType() {
        this.selectedClasses = constants_1.INITIAL_FIELDS.selectedClasses;
        this.setClassType(constants_1.INITIAL_FIELDS.classType);
    }
    clearAll() {
        this.drippingId = constants_1.INITIAL_FIELDS.drippingId;
        this.key = drippingFormUtil_1.default.generateKey();
        this.clearReleaseFields();
        this.clearExpirationFields();
        this.clearClassType();
    }
    get isValid() {
        const validationFields = {
            isReleaseEnabled: this.isReleaseEnabled,
            releaseDrippingType: this.releaseDrippingType,
            releaseNumberOfDays: this.releaseNumberOfDays,
            releaseDateTimeISO: this.releaseDateTimeISO,
            isExpirationEnabled: this.isExpirationEnabled,
            expirationNumberOfDays: this.expirationNumberOfDays,
            classType: this.classType,
            selectedClasses: this.selectedClasses,
            quizId: this.quizId
        };
        return new storeValidation_1.default(validationFields).isValid();
    }
}
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "isReleaseEnabled", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "releaseDrippingType", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "releaseNumberOfDays", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "releaseDateTimeISO", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "isExpirationEnabled", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "expirationNumberOfDays", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "classType", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "selectedClasses", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "quizId", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "quizRequiresMinimumScore", void 0);
__decorate([
    mobx_1.observable
], DrippingFormStore.prototype, "quizDetails", void 0);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setIsReleaseEnabled", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setReleaseDrippingType", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setReleaseNumberOfDays", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setReleaseDateTimeValue", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setIsExpirationEnabled", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setExpirationNumberOfDays", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setClassType", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setSelectedClasses", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setQuizId", void 0);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setQuizRequiresMinimumScore", void 0);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "setAllFields", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "clearReleaseFields", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "clearExpirationFields", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "clearClassType", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "clearAll", null);
__decorate([
    mobx_1.action
], DrippingFormStore.prototype, "addQuizDetails", void 0);
__decorate([
    mobx_1.computed
], DrippingFormStore.prototype, "isValid", null);
exports.default = new DrippingFormStore();
